export function isParamValid(param) {
  return param && !['null', 'undefined'].includes(param)
}
